import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { buildApiUrl } from '../config/api';
import '../styles/Common.css'; // 공통 스타일

const Main = () => {
  const [updates, setUpdates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(buildApiUrl('/api/notice_list'))
      .then(response => {
        setUpdates(response.data); // 이미 서버에서 높은 순서 5개만 가져오므로 그대로 사용
      })
      .catch(error => {
        console.error('Error fetching update list:', error);
      });
  }, []);

  const handleItemClick = (no) => {
    navigate(`/update/${no}`);
  };

  return (
    <div className="common-container half-width">
      <h1>업데이트 내역</h1>
      <ul className="update-list">
        {updates.map(update => (
          <li 
            key={update.no} 
            className="update-item" 
            onClick={() => handleItemClick(update.no)}
          >
            {update.Title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Main;
